const getters = {
  getLastCalled: (state) => (key) => {
    return state.lastCalled[key];
  },
};

export { getters };
